import { stylesheet } from "typestyle";

export default stylesheet({
  input: {},
});
